<ng-content select="app-card-avatar"></ng-content>
<ng-content select="app-card-content"></ng-content>
<ng-content select="app-card-actions"></ng-content>
<app-selection-indicator *ngIf="selectable"
                         [selected]="selected">
</app-selection-indicator>
